'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: block;\n    padding: 1rem 0;\n  '], ['\n    display: block;\n    padding: 1rem 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _H = require('UIComponents/elements/headings/H3');

var _H2 = _interopRequireDefault(_H);

var _UIScrollContainer = require('UIComponents/scroll/UIScrollContainer');

var _UIScrollContainer2 = _interopRequireDefault(_UIScrollContainer);

var _H3 = require('UIComponents/elements/headings/H6');

var _H4 = _interopRequireDefault(_H3);

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _colors = require('HubStyleTokens/colors');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _ProductCatalogTableCell = require('pricing-pages-unified-ui/components/product-catalog/ProductCatalogTableCell');

var _ProductCatalogTableCell2 = _interopRequireDefault(_ProductCatalogTableCell);

var _ProductCatalogTableRow = require('pricing-pages-unified-ui/components/product-catalog/ProductCatalogTableRow');

var _ProductCatalogTableRow2 = _interopRequireDefault(_ProductCatalogTableRow);

var _ProductPageIcons = require('pricing-pages-unified-ui/constants/ProductPageIcons');

var _ProductPageIcons2 = _interopRequireDefault(_ProductPageIcons);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _wtDebounce = require('../../utils/wtDebounce');

var _wtDebounce2 = _interopRequireDefault(_wtDebounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MODAL_WIDTH = 1200;
var HEADER_HEIGHT = 128;
var MODAL_TOP_MARGIN = 60;
var MODAL_BOTTOM_MARGIN = 47;
var headerKeys = ['features', 'free', 'starter', 'professional', 'enterprise'];

var HeaderSection = _styledComponents2.default.div.withConfig({
  displayName: 'ProductCatalogModal__HeaderSection'
})(['box-shadow:0 2px 4px 0 rgba(37,37,37,0.2);z-index:100;']);

var ModalHeader = _styledComponents2.default.div.withConfig({
  displayName: 'ProductCatalogModal__ModalHeader'
})(['text-align:center;background-color:', ';padding:20px 0;& > h3{margin:0;}img{height:20px;}'], _colors.GYPSUM);

var TopHeaderCell = _styledComponents2.default.th.withConfig({
  displayName: 'ProductCatalogModal__TopHeaderCell'
})(['padding:20px;background-color:', ';height:50px;text-align:center;width:18.75%;min-width:175px;& > h6{margin:0;}:first-child{width:25%;text-align:left;}'], _colors.OLAF);

var Table = _styledComponents2.default.table.withConfig({
  displayName: 'ProductCatalogModal__Table'
})(['border-spacing:0;width:100%;margin-bottom:0;']);

var TierSelector = _styledComponents2.default.div.withConfig({
  displayName: 'ProductCatalogModal__TierSelector'
})(['display:none;width:90%;margin:0 auto;padding:2rem 0;text-align:center;button{font-size:0.75rem;cursor:pointer;padding:calc(1rem + 1px) 2rem;background:#fff;border:1px solid #7fd1de;flex-basis:25%;margin-right:-1px;text-align:center;transition:background-color 0.3s;&:hover{background-color:#e5f5f8;}&.active{font-weight:500;padding:1rem 2rem;border-width:2px;border-color:#00a4bd;background-color:#e5f5f8;}}button:first-child{border-radius:3px 0 0 3px;}button:last-child{border-radius:0 3px 3px 0;margin-right:0;}ul{display:none;list-style:none;padding:0;width:60%;margin:0 auto;text-align:left;li{font-size:16px;cursor:pointer;color:#0091ae;}}#tierToggle{position:absolute;top:-9999px;left:-9999px;}input[type=\'checkbox\']:checked ~ label ~ ul{display:block;}', ';', ';'], _responsiveBreakpoints2.default.tabletPortrait(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var TierSelected = _styledComponents2.default.label.withConfig({
  displayName: 'ProductCatalogModal__TierSelected'
})(['color:#0091ae;font-size:18px;font-weight:600;margin-right:3px;cursor:pointer;']);

var ProductCatalogModal = function (_React$Component) {
  _inherits(ProductCatalogModal, _React$Component);

  function ProductCatalogModal() {
    _classCallCheck(this, ProductCatalogModal);

    var _this = _possibleConstructorReturn(this, (ProductCatalogModal.__proto__ || Object.getPrototypeOf(ProductCatalogModal)).call(this));

    _this.handleTierSelect = function (keyToSet) {
      _this.setState({
        activeColumn: keyToSet
      });
    };

    _this.handleWindowSizeChange = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    _this.state = {
      width: window.innerWidth,
      activeColumn: 0
    };
    return _this;
  }

  _createClass(ProductCatalogModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var resizeWindow = (0, _wtDebounce2.default)(function () {
        _this2.handleWindowSizeChange();
      }, 250);
      window.addEventListener('resize', resizeWindow);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: 'renderTableRows',
    value: function renderTableRows() {
      var hub = this.props.hub;

      var orderedMerchIdsForHub = [_HubMap2.default[hub].highlightedFreeMerch].concat(_toConsumableArray(_HubMap2.default[hub].highlightedPaidMerch));

      var enterpriseFeatureIds = Object.keys(_ImmutableMerchandiseIdMap2.default[(0, _underscore.last)(orderedMerchIdsForHub)].features);
      return enterpriseFeatureIds.map(function (featureId, i) {
        return _react2.default.createElement(
          _ProductCatalogTableRow2.default,
          { featureId: featureId, key: i, hub: hub },
          orderedMerchIdsForHub.map(function (merchId, j) {
            return _react2.default.createElement(_ProductCatalogTableCell2.default, {
              featureId: featureId,
              merchandiseId: merchId,
              key: j
            });
          })
        );
      });
    }
  }, {
    key: 'renderMobileTableRows',
    value: function renderMobileTableRows() {
      var _this3 = this;

      var hub = this.props.hub;

      var orderedMerchIdsForHub = [_HubMap2.default[hub].highlightedFreeMerch].concat(_toConsumableArray(_HubMap2.default[hub].highlightedPaidMerch));

      var enterpriseFeatureIds = Object.keys(_ImmutableMerchandiseIdMap2.default[(0, _underscore.last)(orderedMerchIdsForHub)].features);
      return enterpriseFeatureIds.map(function (featureId, i) {
        return _react2.default.createElement(
          _ProductCatalogTableRow2.default,
          { featureId: featureId, key: i, hub: hub },
          orderedMerchIdsForHub.map(function (merchId, j) {
            if (j === _this3.state.activeColumn) {
              return _react2.default.createElement(_ProductCatalogTableCell2.default, {
                featureId: featureId,
                merchandiseId: merchId,
                colId: j,
                key: j
              });
            }
            return null;
          })
        );
      });
    }
  }, {
    key: 'renderTableHeader',
    value: function renderTableHeader() {
      return _react2.default.createElement(
        Table,
        null,
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            headerKeys.map(function (headerKey, i) {
              return _react2.default.createElement(
                TopHeaderCell,
                { 'data-key': i - 1, key: i },
                _react2.default.createElement(
                  _H4.default,
                  null,
                  _react2.default.createElement(_FormattedMessage2.default, {
                    message: 'pricingPage.pages.products.featureTable.tableHeader.' + headerKey
                  })
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: 'renderMobileTableHeader',
    value: function renderMobileTableHeader() {
      var _this4 = this;

      return _react2.default.createElement(
        Table,
        null,
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            headerKeys.map(function (headerKey, i) {
              if (i === 0 || i - 1 === _this4.state.activeColumn) {
                return _react2.default.createElement(
                  TopHeaderCell,
                  { 'data-key': i - 1, key: i },
                  _react2.default.createElement(
                    _H4.default,
                    null,
                    _react2.default.createElement(_FormattedMessage2.default, {
                      message: 'pricingPage.pages.products.featureTable.tableHeader.' + headerKey
                    })
                  )
                );
              }
              return null;
            })
          )
        )
      );
    }
  }, {
    key: 'renderTierSelector',
    value: function renderTierSelector() {
      var _this5 = this;

      return _react2.default.createElement(
        TierSelector,
        null,
        headerKeys.slice(1).map(function (headerKey, i) {
          return _react2.default.createElement(
            'button',
            {
              onClick: (0, _partial2.default)(_this5.handleTierSelect, i),
              key: i,
              className: _this5.state.activeColumn === i ? 'active' : ''
            },
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'pricingPage.pages.products.featureTable.tableHeader.' + headerKey
            })
          );
        })
      );
    }
  }, {
    key: 'renderPhoneTierSelector',
    value: function renderPhoneTierSelector() {
      var _this6 = this;

      return _react2.default.createElement(
        TierSelector,
        null,
        _react2.default.createElement('input', { type: 'checkbox', id: 'tierToggle' }),
        _react2.default.createElement(
          TierSelected,
          { htmlFor: 'tierToggle' },
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.pages.products.featureTable.tableHeader.' + headerKeys.slice(1)[this.state.activeColumn]
          })
        ),
        _react2.default.createElement(_UIIcon2.default, { name: 'downCarat', size: '12px' }),
        _react2.default.createElement(
          'ul',
          null,
          headerKeys.slice(1).map(function (headerKey, i) {
            return _react2.default.createElement(
              'li',
              { onClick: (0, _partial2.default)(_this6.handleTierSelect, i), key: i },
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'pricingPage.pages.products.featureTable.tableHeader.' + headerKey
              })
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hub = _props.hub,
          onCloseClick = _props.onCloseClick;

      return _react2.default.createElement(
        _UIModal2.default,
        {
          use: 'conversational',
          width: MODAL_WIDTH,
          style: { overflow: 'hidden' },
          onOverlayClick: onCloseClick
        },
        _react2.default.createElement(
          HeaderSection,
          null,
          _react2.default.createElement(
            ModalHeader,
            null,
            _react2.default.createElement(_UIImage2.default, {
              className: 'display-inline m-right-2 m-bottom-2',
              src: _ProductPageIcons2.default[hub]
            }),
            _react2.default.createElement(
              _H2.default,
              { className: 'display-inline' },
              _react2.default.createElement(_FormattedMessage2.default, { message: 'pricing-pages.hubs.' + hub + '.name' })
            ),
            _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: (0, _partial2.default)(onCloseClick) })
          )
        ),
        _react2.default.createElement(
          _react2.default.Fragment,
          null,
          this.state.width <= 500 ? this.renderPhoneTierSelector() : this.renderTierSelector(),
          _react2.default.createElement(
            'div',
            null,
            this.state.width <= 800 ? this.renderMobileTableHeader() : this.renderTableHeader(),
            _react2.default.createElement(
              _UIScrollContainer2.default,
              {
                maxHeight: 'calc(100vh - ' + (HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN) + 'px)',
                scrollDirection: 'vertical'
              },
              _react2.default.createElement(
                Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  this.state.width <= 800 ? this.renderMobileTableRows() : this.renderTableRows()
                )
              ),
              _react2.default.createElement(_FooterMicrocopy2.default, null)
            )
          )
        )
      );
    }
  }]);

  return ProductCatalogModal;
}(_react2.default.Component);

ProductCatalogModal.propTypes = {
  hub: _react.PropTypes.string.isRequired,
  onCloseClick: _react.PropTypes.func.isRequired
};

exports.default = ProductCatalogModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-catalog/ProductCatalogModal.js
// module id = 685
// module chunks = 3 4